import { render, staticRenderFns } from "./ListDeliveryTargets.vue?vue&type=template&id=138a7571&"
import script from "./ListDeliveryTargets.vue?vue&type=script&lang=js&"
export * from "./ListDeliveryTargets.vue?vue&type=script&lang=js&"
import style0 from "./ListDeliveryTargets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports